import { z } from 'zod';

// Page Layout schemas
export const pageLayoutSchema = z.object({
  id: z.string().uuid(),
  siteId: z.string().uuid(),
  name: z.string().min(1, 'Layout name is required').max(100),
  description: z.string().max(500).optional().nullable(),
  components: z.array(z.any()).optional().nullable(), // JSON array of components including content-area (DRAFT)
  publishedComponents: z.string().nullable().optional(), // Snapshot of components at last publish
  publishedAt: z.string().datetime().nullable().optional(), // Timestamp of last publish
  publishedHash: z.string().nullable().optional(), // SHA-256 hash of components at publish time
  isDefault: z.boolean().default(false),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const createPageLayoutSchema = z.object({
  siteId: z.string().uuid(),
  name: z.string().min(1, 'Layout name is required').max(100),
  description: z.string().max(500).optional(),
  components: z.array(z.any()).optional(),
  isDefault: z.boolean().optional(),
});

export const updatePageLayoutSchema = z.object({
  name: z.string().min(1).max(100).optional(),
  description: z.string().max(500).nullable().optional(),
  components: z.array(z.any()).nullable().optional(),
  isDefault: z.boolean().optional(),
});

export const setPageLayoutRequestSchema = z.object({
  layoutId: z.string().uuid().nullable(),
  showLayout: z.boolean().optional(),
});

// Page Layout type exports
export type PageLayout = z.infer<typeof pageLayoutSchema>;
export type CreatePageLayoutRequest = z.infer<typeof createPageLayoutSchema>;
export type UpdatePageLayoutRequest = z.infer<typeof updatePageLayoutSchema>;
export type SetPageLayoutRequest = z.infer<typeof setPageLayoutRequestSchema>;
